import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const skuConverter = async (batchId) => {
  try {
    const response = await axios.get(`/api/extensive-prod-creation/getCreatedProd/${batchId}`);
    const responseObj = response.data;
    const productData = responseObj.productData

    const removeDuplicates = (data) => {
      const uniqueMap = new Map();
    
      data.forEach(item => {
        const key1 = `${item.sku}`; 
    
        if (!uniqueMap.has(key1)) {
          uniqueMap.set(key1, item); 
        }
      });
    
      return Array.from(uniqueMap.values());
    };

    const uniqueData = removeDuplicates(productData);

    const excelData = uniqueData.map((data) => ({
      "Master SKU": data.sku,
      "Vendor SKU": data.sku,
      "Active": "TRUE",
      "Min Order Qty": 1,
      "Lead Time": "",
      "Pricing Tiers": `(1-999|${data.cost})`,
      "Units of Measure": "",
      "Is Default": "TRUE",
      "Auto-P.O. Rounding": "EXACT",
      "Packaging": ""
    }));

    const timeStamp = new Date()
    const formattedDate = `${timeStamp.getMonth() + 1}-${timeStamp.getDate()}-${timeStamp.getFullYear()}`

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const excelBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(excelBlob, `vendor-sku-converter_${batchId}_${formattedDate}.xlsx`);

    console.log("Excel file generated successfully.");
  } catch (error) {
    console.error("Error generating Excel file:", error);
  }
};

export default skuConverter;
